import { Analytics } from '@util/Analytics';
import React, { ReactElement } from 'react';
import { ScreenType, SelectScreenConfig } from '../../config/FlowTypes';
import { useAppStore } from '../../store/Store';
import { dispatchUserData } from '../../store/userData/UserDataActions';
import { QuestionWrapper } from '../styles/Containers';
import { NavigationProps } from './FlowNavigation';
import { MultiSelectLayout, MultiSelectLayoutProps } from './layouts/MultiSelectLayout';

export type MultiSelectScreenConfig<ScreenNames extends string> = SelectScreenConfig<
  ScreenType.MultiSelect,
  MultiSelectLayoutProps,
  ScreenNames
>;

type Props<ScreenNames extends string> = NavigationProps<
  MultiSelectScreenConfig<ScreenNames>,
  ScreenNames
>;

export const MultiSelectScreen = <ScreenNames extends string>(
  props: Props<ScreenNames>
): ReactElement => {
  const { navigation, screenName } = props;
  // TODO: Unsafe cast, there is no guarantee that screenName is a valid UserData key
  const userData = useAppStore((s) => s.userData as Record<string, string[] | undefined>);
  const selected = userData[props.screenName];

  function onSubmitPress(selected: string[]) {
    dispatchUserData({ [screenName]: selected });
    Analytics.track({
      event: Analytics.Event.o_question_answered,
      question: screenName,
      answer: selected,
    });
    navigation.next(props);
  }

  return (
    <QuestionWrapper>
      <MultiSelectLayout
        onPressPrimaryButton={onSubmitPress}
        {...props.layout}
        selected={selected}
        onShowToast={props.onShowToast}
      />
    </QuestionWrapper>
  );
};
